import pinia from "@/store";
import Resumable from "resumablejs";
import router from "@/router";
import { EventBus } from "@/main";

import { Notify } from "../notify/Notify";
import { useGlobalStore } from "../../../store/GlobalStore";

const globalStore = useGlobalStore(pinia);

let resumable = new Resumable({
  target: process.env.VUE_APP_API_BASE_URL,
  fileType: ["mp4"],
  headers: {
    accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  chunkSize: 1 * 1024 * 1024,
  testChunks: false,
  fileParameterName: "video",
  throttleProgressCallbacks: 1,
});

resumable.on("filesAdded", function () {
  (resumable.opts.headers.authorization =
    "Bearer " + localStorage.getItem("token")),
    globalStore.changeLoadingStatus(true);

  // Emit start event for video upload progress
  EventBus.$emit("videoUploadStart");

  resumable.upload();
});

resumable.on("fileProgress", function (file) {
  // Calculate progress percentage
  const progress = Math.round(file.progress() * 100);

  // Emit progress event
  EventBus.$emit("videoUploadProgress", progress);
});

resumable.on("error", function () {
  globalStore.changeLoadingStatus(false);
  Notify.showMessage("error", "حدث خطأ أثناء رفع ملفات الفيديو");
});

resumable.on("complete", function () {
  globalStore.changeLoadingStatus(false);

  // Emit complete event for video upload progress
  EventBus.$emit("videoUploadComplete");

  Notify.showMessage("success", "تم رفع ملفات الفيديو بنجاح");

  setTimeout(() => {
    router.go(-1);
  }, 2000);
});

export default resumable;
